import React from "react"
import ReactDOM from "react-dom/client"
import { Routes } from "@generouted/react-router"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "./index.css"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { Toaster } from "@/components/ui/toaster"
import { GoogleTagManagerProvider } from "@tracktor/react-google-tag-manager"
import { env } from "./env"
import { sentryInit } from "./sdk/sentry"
import { DEV } from "./utils/dev"
import { PosthogPageview } from "./sdk/posthog"

if (!DEV)
	sentryInit()

const queryClient = new QueryClient()

const ReactStrictOnDev: React.FCC = ({ children }) =>
{
	if (DEV)
		return <React.StrictMode>{children}</React.StrictMode>

	return children
}

ReactDOM.createRoot(document.getElementById("root")!).render(
	<ReactStrictOnDev>
		<GoogleTagManagerProvider
			id={env.VITE_GTM_ID}
			options={{ scriptUrl: "https://www.googletagmanager.com/gtag/js" }}
		>
			<QueryClientProvider client={queryClient}>
				<ReactQueryDevtools initialIsOpen={false} />
				<Routes />
				<Toaster />
				{/* <PosthogPageview /> */}
			</QueryClientProvider>
		</GoogleTagManagerProvider>
	</ReactStrictOnDev>
)
